<template>
    <!-- 新闻列表 -->
    <router-link :to="{name:'NewsXq',params:{id:info.id}}" tag="li">
        <div class="img" v-if="info.image"><img :src="info.image" alt="图片"></div>
        <div class="font">
            <p class="tit overhid"><img v-if="info.image===''" src="@/assets/icon.png" alt="">{{info.title}}</p>
            <p class="con overhid2">{{info.subTitle}}</p>
            <p class="date">{{info.createTime}}</p>
        </div>
    </router-link>
</template>
<script>
export default {
    props:['link','info']
}
</script>
<style lang="scss" scoped>
    li{
        width: 100%;
        display: flex;
        margin-bottom: 20px;
        padding: 24px 20px;
        box-sizing: border-box;
        cursor: pointer;
        .img{
        width: 160px;
        height: 124px;
        overflow: hidden;
        flex-shrink: 0;
        margin-right: 20px;
        img{
            width: 100%;
            height: 100%;
            transition: .3s ease-out;
        }
        }
        .font{
          width: 20px;
          flex-grow: 1;
            .tit{
                font-size: 24px;
                line-height: 26px;
                margin-bottom: 12px;
                font-weight: bold;
                img{
                    width: 20px;
                    height: 20px;
                    margin-right: 12px;
                }
            }
            .con,.date{
                font-size: 16px;
                line-height: 24px;
            }
            .date{
                margin-top: 12px;
            }
        }
    }
    li:hover{
        box-shadow: 0 0 20px 0 rgba(186, 186, 186, 0.5);
        .img{
        img{
            transform: scale(1.1);
        }
        }
    }

    @media screen and (max-width: 1200px){
        li{
            .font{
            .tit{
                font-size: 20px;
            }
            .date,.con{
                font-size: 14px;
                line-height: 20px;
            }
            }
        }
    }
    @media screen and (max-width: 768px){
    li{
        display: block;
        background-color: #F0F2F5;
        .img{
            margin-right: 0;
            width: 100%;
            height: auto;
        }
        .font{
            width: 100%;
            .tit{
            margin-top: 20px;
            }
        }
        }
    }

</style>


// WEBPACK FOOTER //
// src/components/listDemo.vue